import { useLocation } from 'react-router-dom';

import { getOnboardingConfig } from '../routes.config';

/**
 * Resolves the onboarding configuration for the current route.
 *
 * @returns {{ config: import('../routes.config').OnboardingRouteConfig | undefined, hasConfig: boolean }}
 */
export function useOnboardingRoute() {
  const { pathname } = useLocation();
  const config = getOnboardingConfig(pathname);

  return {
    config,
    hasConfig: Boolean(config)
  };
}
